import { render, staticRenderFns } from "./audit-details.vue?vue&type=template&id=5e457e95&scoped=true"
import script from "./audit-details.vue?vue&type=script&lang=js"
export * from "./audit-details.vue?vue&type=script&lang=js"
import style0 from "./audit-details.vue?vue&type=style&index=0&id=5e457e95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e457e95",
  null
  
)

export default component.exports